import React from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import classNames from 'classnames';


const DEFAULT_OPTIONS = {
  center: [51.505, -0.09],
  attributionControl: false,
  zoomControl: false,
  fitBoundsPadding: [10, 10],
  dragging: true,
  touchZoom: true,
  zoom: 18,
  minZoom: 2,
  maxZoom: 20,
  maxBounds: new L.LatLngBounds(new L.LatLng(85, -190), new L.LatLng(-85, 200)),
  maxBoundsViscosity: 1
};




export default class Map extends React.Component {

  static defaultProps = {
    options: {}
  };

  constructor(props) {
    super(props);
    this.el = null;
    this.map = null;
  }

  getOptions() {
    let options = this.props.options;
    options = {...DEFAULT_OPTIONS, ...options};

    return options;
  }

  render() {
    let {className} = this.props;
    let cls = classNames('component-map', className);

    return (<div ref={(node) => this.el = node} className={cls}></div>);
  }

  componentDidMount() {
    this.map = L.map(this.el, this.getOptions());
    
    this.addMapMoveEvent();
    this._initTileLayer();
  }

  addMapMoveEvent(){
    let { onDragEnd, onZoomEnd } = this.props;
    if(onDragEnd){
      this.map.on('dragend', ()=>{
        onDragEnd(this.map, 'drag');
      });
    }
    if(onZoomEnd){
      this.map.on('zoomend', ()=>{
        onZoomEnd(this.map, 'zoom');
      });
    }
  }

  _initTileLayer() {
    let url = 'https://google-proxy.zuzuche.com/vt/lyrs=m&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=Galil&scale=';
    let urlTemplate = `${url}${window.devicePixelRatio}`;
    let titleLayer = L.tileLayer(urlTemplate);
    
    titleLayer.addTo(this.map);
    this.map.setView(this.props.center);
    this._fitBounds();
  }


  /**
   * 为什么要搞这样
   * 因为人间惨剧，共用的mapcomponet加了fitbounds导致定位有便宜
   */ 
  _fitBounds() {
    let latLngBounds = this.map.getBounds();

    this.map.fitBounds(latLngBounds, {
      animate: true,
      paddingTopLeft: [40, 50],
      paddingBottomRight: [40, 20]
    });
  }
}




// WEBPACK FOOTER //
// ./src/components/AddressMap/Map.js